import Vue from 'vue'
import {
	Message,
	Menu,
	MenuItem,
	Carousel,
	CarouselItem,
	Image,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Divider,
	Row,
	Col,
	Input,
	Pagination,
	Button,
	Select,
	Option,
	Table,
	TableColumn,
	MessageBox,
	Dialog,
	Form,
	FormItem,
	Cascader,
	RadioGroup,
	Radio,
	Checkbox,
	Popover,
	Upload,
	Submenu,
	Loading
} from 'element-ui';
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Image)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Cascader)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Popover)
Vue.use(Upload)
Vue.use(Submenu)
Vue.use(Loading)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox 
